import { Link } from 'react-router-dom';
import type { Product } from '@/mocks/products';

export default function ProductCard({ product }: { product: Product }) {
  return (
    <div className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200" data-product-shop>
      <Link to={`/category/${product.category}`} className="block relative overflow-hidden">
        <div className="aspect-square overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            title={`${product.name} - 日本精品一区`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        {(product.isNew || product.isHot) && (
          <div className="absolute top-3 left-3 flex gap-1.5">
            {product.isNew && (
              <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-full">
                新品
              </span>
            )}
            {product.isHot && (
              <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-full">
                热卖
              </span>
            )}
          </div>
        )}
      </Link>
      <div className="p-4">
        <p className="text-xs text-secondary-600 mb-1">{product.categoryName}</p>
        <Link to={`/category/${product.category}`} className="block">
          <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
            {product.name}
          </h3>
        </Link>
        <p className="text-xs text-foreground-500 mt-1.5 line-clamp-1">{product.description}</p>
        <div className="flex items-center justify-between mt-3">
          <div className="flex items-baseline gap-2">
            <span className="text-lg font-semibold text-primary-600">&yen;{product.price}</span>
            <span className="text-xs text-foreground-400 line-through">&yen;{product.originalPrice}</span>
          </div>
          <div className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span>{product.rating}</span>
          </div>
        </div>
        <div className="mt-1 text-xs text-foreground-400">
          已售 {product.sales >= 1000 ? `${(product.sales / 1000).toFixed(1)}k` : product.sales} 件
        </div>
      </div>
    </div>
  );
}